import IconButton from '@/global/components/Button/IconButton'
import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import { hasPermission } from 'hooks/useBackendMenu'
import { PencilIcon, Trash2Icon } from 'lucide-react'
import { Ajuste } from 'service/api'

export function BotaoEditar({ row }: GridCellParams<Ajuste>) {
    const [tipo, id] = row.id.split('_')
    return hasPermission(['update', tipoAusenciaToPermission(tipo)], () => (
        <IconButton
            href={`/manutencao-ponto/ausencias/${tipo}/${id}/editar`}
            title="Editar"
        >
            <PencilIcon />
        </IconButton>
    ))
}

export function BotaoExcluir({ row }: GridCellParams<Ajuste>) {
    const [tipo, id] = row.id.split('_')
    return hasPermission(['delete', tipoAusenciaToPermission(tipo)], () => (
        <IconButton
            href={`/manutencao-ponto/ausencias/${tipo}/${id}/excluir`}
            title="Excluir"
        >
            <Trash2Icon className="text-red-500" />
        </IconButton>
    ))
}

export function tipoAusenciaToPermission(tipo: string) {
    switch (tipo) {
        case 'afastamento':
            return 'Afastamentos' as const
        case 'abono':
            return 'Abonos' as const
        case 'compensacao-feriado':
            return 'CompensaçãoDeFeriados' as const
        case 'falta-injustificada':
        case 'falta-justificada':
            return 'FaltasJustificadasOuInjustificadas' as const
        default:
            throw new Error(`Tipo de ausência desconhecido: ${tipo}`)
    }
}
